"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var saveConversationsOption_1 = require("../actions/saveConversationsOption");
var ChoiceGroup_1 = require("office-ui-fabric-react/lib/ChoiceGroup");
var owa_session_store_1 = require("owa-session-store");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var React = require("react");
var react_1 = require("satcheljs/lib/legacy/react");
var CONVERSATION_VIEW_OFF_KEY = 'Off';
var ConversationsQuick = /** @class */ (function (_super) {
    tslib_1.__extends(ConversationsQuick, _super);
    function ConversationsQuick() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (ev, option) {
            if (option.key === CONVERSATION_VIEW_OFF_KEY) {
                saveConversationsOption_1.saveConversationsOptionQuick(false);
            }
            else {
                saveConversationsOption_1.saveConversationsOptionQuick(true, option.key);
            }
        };
        return _this;
    }
    ConversationsQuick.prototype.render = function () {
        var userOptions = this.props.userOptions;
        var selectedKey = userOptions.GlobalListViewTypeReact === 1 /* Message */
            ? CONVERSATION_VIEW_OFF_KEY
            : userOptions.ConversationSortOrderReact;
        return (React.createElement(ChoiceGroup_1.ChoiceGroup, { "aria-labelledby": this.props.headerAriaId, selectedKey: selectedKey, options: [
                {
                    key: 'ChronologicalNewestOnTop',
                    text: owa_options_strings_1.default.options_conversations_quick_sortOrderTop,
                },
                {
                    key: 'ChronologicalNewestOnBottom',
                    text: owa_options_strings_1.default.options_conversations_quick_sortOrderBottom,
                },
                {
                    key: CONVERSATION_VIEW_OFF_KEY,
                    text: owa_options_strings_1.default.options_conversations_quick_messageView,
                },
            ], onChange: this.onChange }));
    };
    ConversationsQuick = tslib_1.__decorate([
        react_1.reactive({
            userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
        })
    ], ConversationsQuick);
    return ConversationsQuick;
}(React.Component));
exports.default = ConversationsQuick;
//# sourceMappingURL=ConversationsQuick.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-conversations-option/lib/components/ConversationsQuick.js
// module id = 5077
// module chunks = 2